import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  card: { padding: 20, marginTop: 20 },
  username: {
    color: "#58595b",
    paddingTop: 10,
    paddingBottom: 10,
  },
  formControl: {
    paddingBottom: 20,
    paddingRight: 20,
    width: "90%",
  },
  button: {
    marginLeft: 20,
    marginTop: 30,
  },
}));

export default useStyles;
